import { WatchlistSorting } from './types';

export const isWatchlistSorting = (s: unknown): s is WatchlistSorting =>
  Object.values<unknown>(WatchlistSorting).includes(s);
